<template>
  <div id="app">
    <router-view/>
    <div class="builder-modal">
      <sweet-modal overlay-theme="dark" ref="builderModal" @close="onCloseModal">
        <iframe id="builder-modal" :src="builderPath" v-if="vModal.builder"></iframe>
      </sweet-modal>
    </div>
    <portal-target name="modal" multiple></portal-target>
  </div>
</template>

<script>
  let fernet = require('fernet');
  import {SweetModal} from 'sweet-modal-vue'

  export default {
    name: 'App',
    components: {
      SweetModal
    },
    head: {
      title: function () {
        return {
          inner: this.serviceName,
          complement: ''
        }
      },
      /*link: function() {
        return [
          {
            rel: 'icon',
            href: this.favicon,
            type: 'image/x-icon'
          }
        ];
      }*/
    },
    computed: {
      serviceName() {
        let name = this.$store.getters.serviceName + ' 관리자';
        if(this.backendUrl.search('theme-dev') > -1){
          name = '런치팩 관리자';
        }
        return name;
      },

      /*favicon() {
        return this.$store.getters.favicon;
      }*/
    },
    data(){
      return{
        service_name:'',
        xServerkey: '',
        pageName: '',
        vModal: {
          builder: false
        },
        builderPath: ''
      }
    },
    watch: {
      /*serviceName(n) {
        this.$emit('updateHead');
      }*/
      '$route.params'(n) {
        if (n.theme_key !== undefined) {
          if (this.$axios.defaults.headers.common['X-Database'] === undefined)
            this.$axios.defaults.headers.common['X-Database'] = n.theme_key;

          if (this.$store.getters.backendData.social_key === undefined)
            this.getAPIKey();
        }

        this.getData(this.xServerkey);
      },

      /*favicon(n) {
        this.$emit('updateHead');
      }*/
    },
    beforeMount() {
      const {body} = document
      const WIDTH = 768
      const RATIO = 3

      const handler = () => {
        if (!document.hidden) {
          let rect = body.getBoundingClientRect()
          let isMobile = rect.width - RATIO < WIDTH
        }
      }


      document.addEventListener('visibilitychange', handler)
      window.addEventListener('DOMContentLoaded', handler)
      window.addEventListener('resize', handler)
    },
    created() {
      if(location.href.indexOf('/office/admin/frbuilder') >-1) {
        return;
      } else if(location.search === '?builder=true'){
        this.$store.commit('setFromBuilder');
      } else if(location.search === '?app_market=true'){
        this.$store.commit('setOpenAppMarket', true);
      }

      this.$store.commit('setMode', location.pathname.split('/')[2]);
      this.$root.$on('builder', () => {
        window.addEventListener('message', this.onMessage);
        let service = this.$store.getters.getServiceSetting;
        this.builderPath = `https://${service.service_key}.launchpack.co.kr/developers/common`;
        //this.builderPath = `http://localhost:8080/common`;
        this.vModal.builder = true;
        this.$store.commit('setLoading', true);
      });

      // 서비스 정보 가져오기
      this.$axios.get(this.backendUrl+'/public/service/info')
        .then(res => {
          if(res.status === 200) {
            this.$store.commit('setServiceName',res.data.title);
            if(res.data.info) {
              this.$store.commit('setMasterService', res.data.info);
            }
            this.$emit('updateHead');
          }
        });

      // 데이터베이스 키 가져오기
      var req = new XMLHttpRequest();
      req.open('GET', document.location.origin, false);
      req.send(null);
      let xServerkey = req.getResponseHeader('x-serverkey');
      if (xServerkey) {
        if (xServerkey !== 'theme') {
          this.$axios.defaults.headers.common['X-Database'] = xServerkey;
        }
      }

      this.$axios.defaults.baseURL = this.backendUrl;

      this.setAuthHeader()

      this.xServerkey = xServerkey;
      // this.getData(xServerkey);

      this.$router.afterEach((to, from) => {
        // if (to.path === '/' && to.params.id === undefined)
        //   this.$router.replace('/office/admin')
        this.$store.commit('setPreviousPath', to.fullPath);

        // 배포된 서비스에서 열때 해당 페이지 열리는 동작 처리
        if (to.path === '/office/admin' && to.query.front_path !== undefined) {
          this.routerFrontPath(to.query.front_path, to.query.front_id);
          return;
        }
        else if (to.path === '/office/admin' && to.params.id === undefined) {
          //this.$router.replace('/office/admin/dashboard');
          this.$router.replace('/office/admin/germany/ship_agency/order_list_all');

        }
        else if (to.path === '/office/partner' && to.params.id === undefined)
          this.$router.replace('/office/partner/dashboard');

        else if (to.path === '/office/space_partner' && to.params.id === undefined)
          this.$router.replace('/office/space_partner/dashboard');

        else if (to.path === '/office/supervisor' && to.params.id === undefined)
          this.$router.replace('/office/supervisor/dashboard');

        else if(this.$route.params.theme_key){
          if (to.path === `/office/admin/theme/${this.$route.params.theme_key}` && to.params.id === undefined)
            this.$router.replace(this.getPath('dashboard'));
        }

        if (location.href.indexOf('/office/admin') > -1 && location.href.indexOf('frbuilder') === -1) {
          if (this.$store.getters.admin.token === '' || this.$store.getters.mode !== 'admin') {
            let query = '';
            if(this.$route.query.pf) {
              query = `?pf=${this.route.query.pf}`;
            }
            this.$router.replace(`/office/admin/login${query}`);
          }
        } else if (location.href.indexOf('/office/partner') > -1){
          if (this.$store.getters.partner.token === '' || this.$store.getters.mode !== 'partner') {
            if(location.pathname !== '/office/partner/login')
              this.$router.replace('/office/partner/login');
          }
        } else if (location.href.indexOf('/office/space_partner') > -1){
          if (this.$store.getters.partner.token === '' || this.$store.getters.mode !== 'space_partner') {
            if(location.pathname !== '/office/space_partner/login')
              this.$router.replace('/office/space_partner/login');
          }
        } else if (location.href.indexOf('/office/superpartner') > -1){
          if (this.$store.getters.superpartner.token === '' || this.$store.getters.mode !== 'superpartner')
            this.$router.replace('/office/superpartner/login');
        } else if (location.href.indexOf('/office/supervisor') > -1){
          if (this.$store.getters.supervisor.token === '' || this.$store.getters.mode !== 'supervisor')
            this.$router.replace('/office/supervisor/login');
        }
      })
    },
    methods: {
      onCloseModal() {
        this.vModal.builder = false;
        window.removeEventListener('message', this.onMessage);
      },
      onMessage(e) {
        if(e.data.builder === 'ready') {
          this.$nextTick(()=>{
            setTimeout(()=>{
              document.getElementById('builder-modal').contentWindow.postMessage({
                admin: this.$store.getters.admin
              }, '*');
              this.$refs.builderModal.open();
              this.$store.commit('setLoading', false);
            },100);
          });
        }
      },
      // 내부 플러그인 가져오기
      getInternalPlugin() {
        if(!this.isLaunchpack) {
          this.$axios.get('public/service/internal-plugin')
            .then(res => {
              if (res.status === 200) {
                this.$store.commit('setInternalPlugin', res.data.internal_plugin);
                //console.log(res.data.internal_plugin)
              }
            });
        }
      },
      getPackages() {
        return this.$axios.get('public/service/packages').then(res=> {
          this.$store.commit('setPackages', res.data);
          return res.data;
        });
      },
      // 패키지에 따라서 api_key를 호출하는 경우가 다르기 때문에 절차적으로
      // 패키지를 먼저 가져와서 런치팩일 경우 조건을 추가해줌.
      // packages[0].name !== 'launchpack'
      async getData(xServerkey) {
        // 패키지 저장
        let packages =  await this.getPackages();
        if (xServerkey !== 'theme' && packages[0].name !== 'launchpack') {
          this.getAPIKey()
        }

        if (process.env.NODE_ENV.indexOf('master') === -1 && packages[0].name !== 'launchpack') {

          // 브랜드 정보 가져오기
          /*this.$axios.get(this.backendUrl + '/public/ui/brand/admin')
            .then(res => {
              if (res.status === 200) {
                this.$store.commit('setBrand', res.data);
              }
            });*/
        }

        await this.getInternalPlugin();
      },
      getAPIKey() {
        if (process.env.NODE_ENV.indexOf('master') === -1) {
          this.$axios.get(this.backendUrl + '/public/service/social_key')
            .then(res => {
              if (res.status === 200) {
                let keys = undefined;
                if(res.data.result) {
                  let result = res.data.result.split('_!_');
                  let token = new fernet.Token({secret: new fernet.Secret(result[1]), token:result[0], ttl:0});
                  keys = JSON.parse(token.decode());
                } else {
                  keys = res.data.social_key;
                }
                this.$store.commit('setBackendData', {social_key: keys});
              }
            })
            .catch(err => {
              //console.log(err);
            });
        }
      },
      routerFrontPath(path,id) {
        const paths = [
          {
            path: ['home',],
            route: 'dashboard'
          },
          {
            path: ['mypage','signin'],
            route: 'user'
          },
          {
            path: ['profile','signup'],
            route: 'user/param/form'
          },
          {
            path: ['company',],
            route: 'service/info'
          },
          {
            path: ['privacy','termsofservice'],
            route: 'service/policy'
          },
          {
            path: ['partner','partner_search'],
            route: 'partner'
          },
          {
            path: ['partner_detail',],
            route: 'partner/create'
          },
          {
            path: ['product','product_search'],
            route: 'product'
          },
          {
            path: ['product_detail',],
            route: 'product/create'
          },
          {
            path: ['event'],
            route: 'event'
          },
          {
            path: ['event_detail',],
            route: 'event/create'
          },
          {
            path: ['board', 'my_post', 'post', 'post_reg'],
            route: 'board'
          },
          {
            path: ['contact','contact_reg','contact_detail'],
            route: 'cs/inquiry/new'
          },
          {
            path: ['call_list',],
            route: 'cs/call/new'
          },
          {
            path: ['cancel_detail_delivery', 'cancel_done_delivery', 'order_cancel_delivery'],
            route: 'delivery/order_list_cancel_new'
          },
          {
            path: ['exc_detail_delivery', 'exc_done_delivery', 'exc_reason_delivery', 'exc_way_delivery',],
            route: 'delivery/order_list_exchange_new'
          },
          {
            path: ['exhibition'],
            route: 'exhibition'
          },
          {
            path: ['exhibition_detail'],
            route: 'exhibition/create'
          },
          {
            path: ['partner_exhibition_detail'],
            route: 'exhibition_partner/create'
          },
          {
            path: ['faq'],
            route: 'faq'
          },
          {
            path: ['inquiry_reg', 'my_inquiry'],
            route: 'product/inquiry/new'
          },
          {
            path: ['review_reg', 'my_review'],
            route: 'product/review/new'
          },
          {
            path: ['my_coupon',],
            route: 'coupon'
          },
          {
            path: ['my_point',],
            route: 'point/setting'
          },
          {
            path: ['notice',],
            route: 'notice'
          },
          {
            path: ['notice_detail',],
            route: 'notice/create'
          },
          {
            path: ['notice',],
            route: 'notice'
          },
          {
            path: ['order_booking','order_detail_booking','order_done_booking','reserve_option_booking'],
            route: 'booking/order_list_new'
          },
          {
            path: ['order_reservation','order_detail_reservation','order_done_reservation','reserve_option_reservation'],
            route: 'reservation/order_list_new'
          },
          {
            path: ['order_delivery','order_detail_delivery','order_done_delivery'],
            route: 'delivery/order_list_pay_all'
          },
          {
            path: ['order_shipping_delivery',],
            route: 'delivery/order_list_delivery_all'
          },
          {
            path: ['ret_detail_delivery',],
            route: 'delivery/order_list_back_new'
          },
          {
            path: ['ret_detail_delivery','ret_done_delivery','ret_reason_delivery','ret_way_delivery'],
            route: 'delivery/order_list_back_new'
          },
          {
            path: ['service_guide',],
            route: 'guide'
          },
        ];
        let route = paths.filter(i=>{ return i.path.indexOf(path) > -1 });
        if(route.length === 0) {
          route = 'dashboard';
        } else {
          route = route[0].route;
          if(path.indexOf('_detail')>-1 && id) {
            route += `?id=${id}`;
          }
        }
        this.$router.replace(`/office/admin/${route}`);
      },
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  iframe
    width 100%
    height 90vh
</style>
<style lang="stylus">
  .builder-modal
    .sweet-modal.is-alert
      background-color transparent
      width 1000px
      box-shadow unset
    .sweet-modal.is-alert .sweet-content
      padding 0
    .sweet-modal .sweet-box-actions .sweet-action-close
      color white
    .sweet-modal .sweet-box-actions .sweet-action-close:hover
      background-color transparent
    .sweet-modal .sweet-box-actions
      top 6px

</style>
